<template>
    <div>
        <page-title v-if="item" :title="item.title" />
        <b-row v-if="item">
            <b-col>
                <div v-html="contentBlock"></div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import marked from 'marked'
    import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

    export default {
        name: "ContentBlockView",
        mixins: [
            CrudOperationsMixin
        ],
        props: [
            'id',
            'name'
        ],
        data() {
            return {
                item: null,
            };
        },
        computed: {
            contentBlock: function () {
                return marked(this.item.value);
            }
        },
        methods: {
            scrollToHash: function () {
                let hash = this.$route.hash;
                if (!hash)
                    return;

                // This is called when the AJAX request returns the content, but before Vue has rendered it
                this.$nextTick(() => {
                    let el = document.querySelector(hash);
                    el.scrollIntoView();
                });
            },
            load: function () {

                if (this.id) {
                    this.readQuery('/graphql/public', {
                        query: `
              query ($id: ID) {
                contentBlock (id: $id) {
                  id,
                  name,
                  value,
                }
              }`,
                        variables: {
                            'id': this.id
                        }
                    }, (data) => {
                        this.item = data.contentBlock;
                        this.scrollToHash();
                    });
                } else if (this.name) {
                    this.readQuery('/graphql/public', {
                        query: `
            query ($filter: String) {
              contentBlocks (filter: $filter) {
                id,
                name,
                title,
                slug,
                value
              }
            }`,
                        variables: {
                            'filter': 'slug = "' + this.name + '"'
                        }
                    }, (data) => {
                        if (data.contentBlocks && data.contentBlocks.length == 1) {
                            this.item = data.contentBlocks[0];
                            this.scrollToHash();
                        } else
                            this.item = null;
                    });
                }
            }
        },
        watch: {
            '$route'(to, from) {
                this.load();
            }
        },
        mounted() {
            this.load();
            // Use this instead of the previous line to test the "Loading" bar
            //window.setTimeout(this.load, 3000);
        }
    };
</script>